import { selectApiData } from 'util/selector/apiSelector';

import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';
import { Dayjs } from 'dayjs';

import {
  mapProjectSettingsDtoToModel,
  ProjectSettingsDto,
  ProjectSettingsModel,
} from './dto/ProjectSettings.dto';
import {
  mapSurveySettingsModelToDatesDto,
  mapSurveySettingsModelToDto,
  SurveySettingsModel,
} from './dto/SurveySettings.dto';
import { mapProjectDtoToModel, ProjectModel } from './dto/Project.dto';
import {
  mapPrecedingSurveyCloseDateDtoToModel,
  PrecedingSurveyCloseDateDto,
} from './dto/PrecedingSurveyCloseDate.dto';

export class ProjectSettingsApi {
  constructor(private client: AxiosInstance) {}

  fetch(projectId: number): Promise<ProjectSettingsModel> {
    return this.client
      .get<WithData<ProjectSettingsDto>>(`/api/v1/project/${projectId}/settings`)
      .then(selectApiData)
      .then(mapProjectSettingsDtoToModel);
  }

  update(id: number, data: SurveySettingsModel): Promise<ProjectModel> {
    return this.client
      .post(`/api/v1/project/${id}`, mapSurveySettingsModelToDto(data))
      .then(selectApiData)
      .then(mapProjectDtoToModel);
  }

  getPrecedingSurveyCloseDate(projectId: number): Promise<Dayjs | null> {
    return this.client
      .get<
        WithData<PrecedingSurveyCloseDateDto>
      >(`/api/v1/project/${projectId}/preceding-survey-close-date`)
      .then(selectApiData)
      .then(mapPrecedingSurveyCloseDateDtoToModel);
  }

  async updateDates(projectId: number, data: SurveySettingsModel): Promise<void> {
    await this.client.post(
      `/api/v1/project/${projectId}/change-dates`,
      mapSurveySettingsModelToDatesDto(data),
    );
  }
}
